import { css, html } from 'react-strict-dom';

import { Style } from '../constants';
import { color } from '../constants/color.css';
import { pulseSquares } from './pulse-grid';
import Text from './Text';

const pulse = css.keyframes({
  '0%': { opacity: 0.15 },
  '50%': { opacity: 1 },
  '100%': { opacity: 0.15 },
});

/**
 * The default in-flow loader. Renders inside the page's normal container so the
 * shell stays put and the browser keeps scroll position.
 */
export default function PageLoading() {
  return (
    <html.div aria-busy style={[Style.col, Style.centerBoth, styles.wrap]}>
      <html.div aria-hidden style={styles.grid}>
        {pulseSquares().map((square, index) => (
          <html.span
            key={index}
            style={[
              styles.square,
              styles.stagger(square.staggerSeconds),
              styles.opacity(square.opacity),
            ]}
          />
        ))}
      </html.div>
      <html.span aria-hidden>
        <Text typeface="body.small.regular" color="neutral60">
          Loading&hellip;
        </Text>
      </html.span>
      <html.span aria-live="polite" role="status" style={styles.visuallyHidden}>
        Loading&hellip;
      </html.span>
    </html.div>
  );
}

const styles = css.create({
  wrap: {
    gap: 12,
    minHeight: '60vh',
    paddingBlock: 24,
    paddingInline: 16,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 6px)',
    gap: 3,
    width: 24,
    height: 24,
  },
  square: {
    width: 6,
    height: 6,
    backgroundColor: color.accent,
    animationName: pulse,
    animationDuration: '1.4s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
    '@media (prefers-reduced-motion: reduce)': {
      animationName: 'none',
    },
  },
  stagger: (seconds: number) => ({
    animationDelay: `${-seconds}s`,
  }),
  opacity: (opacity: number) => ({
    opacity,
  }),
  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: 0,
  },
});
